module.exports = __webpack_public_path__ + "img/app-xzbg.8ee35e67.png";